 import {  beablooApi } from "../../utils";
 
const promotionUpdate = async (payload,belongsTo, id) => {

    const response =  await beablooApi({
      method: 'PUT',
      route: `/developments/${belongsTo}/promotions/${id}/update`,
      payload: payload
    });

     if (!response.success) {
    throw new Error('unable to update promotion')
  }

  return response.data;
  };


  const promotionService = {
  promotionUpdate
};

export default promotionService;
